import { BaseSyntheticEvent, useState } from 'react';
import { MessageBubble, MessageImage, MessageText } from '@engyalo/design-system';
import { formatMessageTime } from 'helpers/formatterDates';
import { useTranslation } from 'react-i18next';
import MediaMessageFallback from '../MediaMessageFallback';
import { logError } from '../../../../services/Logger';
import { MESSAGE_VARIANT_MAP, MessageVariant } from '../TextMessage/TextMessage';
import { AuthorRoles, BOT_NAME, MESSAGE_ID_PREFIX } from '../ChatMessage.constants';
import { ChatMessageComponentProps } from '../ChatMessage';
import { ImageAnchor } from './styled';

const ImageMessage: React.FC<ChatMessageComponentProps> = ({
  authorRole,
  image,
  id,
  name,
  messageStatus,
  timestamp,
  username,
  error,
}) => {
  const [hasError, setHasError] = useState(false);
  const { i18n } = useTranslation();

  const messageVariant = error || hasError ? MessageVariant.ERROR : MESSAGE_VARIANT_MAP[authorRole];
  const isAgent = authorRole === AuthorRoles.AGENT || authorRole === AuthorRoles.BOT;
  const displayName = name || username || BOT_NAME;
  const sentAt = formatMessageTime(Number(timestamp), i18n.language);

  if (!image) {
    return null;
  }

  const { url, caption } = image;

  const handleImageError = (event: BaseSyntheticEvent) => {
    setHasError(true);
    logError('Error loading image', event.target.error, { event, targetURL: url });
  };

  return hasError ? (
    <MediaMessageFallback />
  ) : (
    <MessageBubble
      disableAutoGroup
      id={`${MESSAGE_ID_PREFIX}${id}`}
      data-testid={`chat-message-image-${id}`}
      variant={messageVariant}
      status={messageStatus}
      displayName={isAgent ? undefined : displayName}
      sentAt={sentAt}
      onError={() => setHasError(true)}
    >
      <ImageAnchor href={url} target="_blank" rel="noopener noreferrer">
        <MessageImage src={url} alt={caption || ''} loading="lazy" onError={handleImageError} />
      </ImageAnchor>
      {caption && <MessageText body={caption} />}
    </MessageBubble>
  );
};

export default ImageMessage;
